import { render, staticRenderFns } from "./CreateYouTubeChannel.vue?vue&type=template&id=a03b5730&scoped=true"
import script from "./CreateYouTubeChannel.vue?vue&type=script&lang=js"
export * from "./CreateYouTubeChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateYouTubeChannel.vue?vue&type=style&index=0&id=a03b5730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03b5730",
  null
  
)

export default component.exports